// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3nGyD","productName":"Table_productName__2dzsi"};